import { createFileRoute } from "@tanstack/react-router";
import MyListingsV2 from "@/pages/MyListingsV2";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/my-listings-v2/")({
  head: () => routeHead("/de/my-listings-v2/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MyListingsV2 />
  );
}
